import filter from "lodash/filter";
import findIndex from "lodash/findIndex";
import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/flashes-actions";

const flashReducer = (state = INITIAL_STATE.flashes, action) => {
  switch (action.type) {
    case TYPES.ADD_FLASH: {
      const { payload } = action;
      const compare = (flash) => flash.key === payload.key || flash.message === payload.message;
      return payload.preventDuplicate && findIndex(state, compare) > -1
        ? state
        : [...state, payload];
    }

    case TYPES.CLOSE_FLASH: {
      return filter(state, (flash) => flash.key !== action.payload);
    }

    case TYPES.CLEAR_FLASHES: {
      return filter(state, "persist");
    }

    default:
      return state;
  }
};

export default flashReducer;
